import { PolicyProps } from "@/lib/types";

export const policyData: PolicyProps[] = [
  {
    id: "collection",
    number: "01",
    title: "Data Collection",
    description:
      "We collect personal information that you provide to us, such as your name, email address, and contact details. We also automatically collect certain information when you visit our site, including your IP address and browsing behavior.",
  },
  {
    id: "usage",
    number: "02",
    title: "How We Use Data",
    description:
      "Octarnal uses your data to provide, maintain, and improve our services. This includes communicating with you about project updates, security alerts, and providing customer support tailored to your unique requirements.",
  },
  {
    id: "protection",
    number: "03",
    title: "Data Protection",
    description:
      "We implement a variety of security measures to maintain the safety of your personal information. Your data is contained behind secured networks and is only accessible by a limited number of persons who have special access rights.",
  },
  {
    id: "cookies",
    number: "04",
    title: "Cookies & Tracking",
    description:
      "Our website uses cookies to enhance your experience. Cookies allow us to remember your preferences and understand how you interact with our platform, enabling us to optimize performance and usability.",
  },
  {
    id: "rights",
    number: "05",
    title: "Your Privacy Rights",
    description:
      "You have the right to access, update, or delete your personal information at any time. Simply reach out to our privacy officer to initiate a data request or to withdraw your consent for data processing.",
  },
];
